import axios from 'axios';
import { mostraSpinner, nascondiSpinner } from './useLoaderHook';
import globals from '../config/appconfig';

const client = axios.create({
    baseURL: globals[ 'app-url-backend-ms-cms-rss' ]
});

const clientRicerca = axios.create({
    baseURL: globals[ 'app-url-backend-ms-ricerca-rss' ]
});

const request = ({ ...options }) => {
    mostraSpinner();

    const onSuccess = (response) => response;

    const onError = (error) => {
        return error;
    };

    const onFinally = () => {
        nascondiSpinner();
    };

    //TODO questo deve essere sostituito per la sessione del utente logato
    client.defaults.headers = {
        "AZContext": "sessionid=ff86e382-97ef-4a95-99c9-40ed1f1e0623;applicationid=RSS;operationid=b3d199ab63b98d43;contesto=null",
    };

    return client(options)
        .then(onSuccess)
        .catch(onError)
        .finally(onFinally);

};

const requestRicerca = ({ ...options }) => {
    mostraSpinner();

    const onSuccess = (response) => response;

    const onError = (error) => {
        return error;
    };

    const onFinally = () => {
        nascondiSpinner();
    };

    //TODO questo deve essere sostituito per la sessione del utente logato
    clientRicerca.defaults.headers = {
        "AZContext": "sessionid=ff86e382-97ef-4a95-99c9-40ed1f1e0623;applicationid=RSS;operationid=b3d199ab63b98d43;contesto=null"
    };

    return clientRicerca(options)
        .then(onSuccess)
        .catch(onError)
        .finally(onFinally);

};


export default client;
export { request, requestRicerca };